/**
 * Represents the ipc renderer channels for sending and receiving event messages
 * between the web application and the electron app.
 */
export var IpcRendererChannel;
(function (IpcRendererChannel) {
    IpcRendererChannel["AsynchronousMessage"] = "asynchronous-message";
    IpcRendererChannel["AsynchronousReply"] = "asynchronous-reply";
})(IpcRendererChannel || (IpcRendererChannel = {}));
